
import { SceneTransition } from "slotworks/graphics/layers/scene-transitions/scene-transition";
import Contract from "slotworks/utils/contract";

export abstract class AbstractSceneTransition implements SceneTransition {
    public in() {
        return Contract.empty();
    }

    public out() {
        return Contract.empty();
    }

    public skipIn() {
        // Skip in
    }

    public skipOut() {
        // Skip out
    }

    public destroy() {
        // Destroy
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/layers/scene-transitions/abstract-scene-transition.ts